
// NOTES:
// Provide intellisense hints : http://weblogs.asp.net/bleroy/archive/2007/04/23/the-format-for-javascript-doc-comments.aspx
// More on js intellisense : http://weblogs.asp.net/scottgu/archive/2007/06/21/vs-2008-javascript-intellisense.aspx

String.prototype.startsWith = function (s) {
    return this.indexOf(s) === 0;
};

String.prototype.padLeft = function (n, pad) {
    t = '';
    if (n > this.length) {
        for (i = 0; i < n - this.length; i++) {
            t += pad;
        }
    }
    return t + this;
}

String.prototype.padRight = function (n, pad) {
    t = this;
    if (n > this.length) {
        for (i = 0; i < n - this.length; i++) {
            t += pad;
        }
    }
    return t;
}

Function.prototype.debounce = function (threshold, execAsap) {

    if (execAsap === undefined) {
        execAsap = true;
    }

    var func = this, timeout;

    return function debounced() {
        var obj = this, args = arguments;
        function delayed() {
            if (!execAsap)
                func.apply(obj, args);
            timeout = null;
        };

        if (timeout)
            clearTimeout(timeout);
        else if (execAsap)
            func.apply(obj, args);

        timeout = setTimeout(delayed, threshold || 100);
    };

};

Function.prototype.trace = function () {

    var trace = [];
    var current = this;

    while (current) {
        trace.push(current.signature());
        current = current.caller;
    }

    return trace;

}

Function.prototype.signature = function () {

    var signature = {
        name: this.getName(),
        params: [],
        toString: function () {
            var params = this.params.length > 0 ?
                "'" + this.params.join("', '") + "'" : "";
            return this.name + "(" + params + ")"
        }
    };

    if (this.arguments) {
        for (var x = 0; x < this.arguments.length; x++)
            signature.params.push(this.arguments[x]);
    }

    return signature;

}

Function.prototype.getName = function () {

    if (this.name)
        return this.name;

    var definition = this.toString().split("\n")[0];
    var exp = /^function ([^\s(]+).+/;
    if (exp.test(definition))
        return definition.split("\n")[0].replace(exp, "$1") || "anonymous";

    return "anonymous";

}

Function.prototype.getWindow = function () {
    return window.id;
};


function parseUri(str) {

    // parseUri 1.2.2
    // (c) Steven Levithan <stevenlevithan.com>
    // MIT License
    // http://blog.stevenlevithan.com/archives/parseuri

    var o = parseUri.options,
        m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
        uri = {},
        i = 14;

    while (i--) uri[o.key[i]] = m[i] || "";

    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
        if ($1) uri[o.q.name][$1] = $2;
    });

    return uri;

};

parseUri.options = {
    // parseUri 1.2.2
    // (c) Steven Levithan <stevenlevithan.com>
    // MIT License
    strictMode: false,
    key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
    q: {
        name: "queryKey",
        parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }

};

var makeCounter = function () {
    /// <summary>Creates an object that implements a private counter</summary>
    // https://developer.mozilla.org/en/JavaScript/Guide/Closures
    var privateCounter = 0;
    function changeBy(val) {
        privateCounter += val;
    }

    return {
        next: function () {
            changeBy(1);
            return privateCounter;
        },
        value: function () {
            return privateCounter;
        }
    }

};

// JMC 2012/03/26
// use this function to get a dictionary
// of querystring values for the current page.
function getQueryString() {
    // Create a variable for the result
    var result = [];
    // Get a reference to the url.
    var qs = window.location.toString();
    // Check if there is a querystring.
    if (qs.indexOf('?') < 0) return result;
    // Grab the querystring.
    var querystring = qs.substr(qs.lastIndexOf('?') + 1);
    // Split the querystring
    var parts = querystring.split('&');
    // Iterate through each part.
    for (var i = 0; i < parts.length; i++) {
        // Get the delimiter for the key/value pair.
        var splitIndex = parts[i].indexOf('=');
        if (splitIndex < 0) continue;

        // Get the key
        var key = parts[i].substr(0, splitIndex);
        // Get the value
        var value = parts[i].substr(splitIndex + 1);
        // Add the key/value pair to our result variable.
        result[key] = value;
    }
    // Return the result
    return result;
}

if (!Date.prototype.toISOString) {
    Date.prototype.toISOString = function () {
        function pad(n) { return n < 10 ? '0' + n : n }
        return this.getUTCFullYear() + '-'
            + pad(this.getUTCMonth() + 1) + '-'
            + pad(this.getUTCDate()) + 'T'
            + pad(this.getUTCHours()) + ':'
            + pad(this.getUTCMinutes()) + ':'
            + pad(this.getUTCSeconds()) + 'Z';
    };
}

Date.prototype.getUTCTime = function () {
    return this.getTime() + (this.getTimezoneOffset() * 60000);
};

Date.prototype.getDSTOffset = function () {
    var offset = 0;
    if (this.isDST() != new Date().isDST() && !this.isDST())
        offset = 1 * 60 * 60 * 1000;
    else if (this.isDST() != new Date().isDST())
        offset = -1 * 60 * 60 * 1000;
    else
        offset = 0;
    return offset;
};